import { render, staticRenderFns } from "./currentinquiry.vue?vue&type=template&id=a79d12c0&scoped=true"
import script from "./currentinquiry.vue?vue&type=script&lang=js"
export * from "./currentinquiry.vue?vue&type=script&lang=js"
import style0 from "./currentinquiry.vue?vue&type=style&index=0&id=a79d12c0&prod&lang=scss&scoped=true"
import style1 from "./currentinquiry.vue?vue&type=style&index=1&id=a79d12c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79d12c0",
  null
  
)

export default component.exports